export enum BinaryButton {
  disabled = '0',
  enabled = '1',
}
